import { COMMITMENT_UPFRONT_TYPE } from "./app";
import { ValueOf } from "./utils";

export const FINANCING_TYPE = {
    SWITCH: "switch",
    LEASE: "lease",
    RESWITCH: "reswitch",
    UPFRONT: "upfront",
} as const;

export const FINANCING_CODE = {
    RESWITCH_LEGACY: "SWITCH_FLEX_TF_B2C",
    RESWITCH: "SWITCH_FLEX_LAST_B2C",
    LEASE: "LEAS_FLEX_B2C",
    UPFRONT: "now",
} as const;

export type FinancingType = ValueOf<typeof FINANCING_TYPE>;
export type FinancingDuration = typeof COMMITMENT_UPFRONT_TYPE | number;
export type FinancingCode = ValueOf<typeof FINANCING_CODE>;

// Max handset or MBB router amount a new-legal-owner customer can have on lease/delbetaling before paying the
// rest upfront (fraud prevention). Shared between frontend and backend so this business number is defined in one
// place; backend config (`server/config/env/production.ts`) reads it via `maxPriceForNewNumber`.
// For lease, this is a fallback when no usable NEO loan/material price limit is available.
export const MAX_PRICE_FOR_NEW_NUMBER = 7500;
